module.exports = __webpack_public_path__ + "static/node-f43a7036047a8afc02e5b46228c34f16.png";